<button *ngIf="mobileMode$ | async" (click)="notificationsMenuItemClicked.emit()" disableRipple mat-menu-item>
    <mat-icon [svgIcon]="'v2:fi-br-bell'"></mat-icon>
    {{ 'Notifications' }}
</button>
<button *memberAccess [routerLink]="['/app/settings/user']" disableRipple mat-menu-item>
    <mat-icon [svgIcon]="'v2:fi-br-settings-sliders'"></mat-icon>
    {{ 'Account Settings' }}
</button>
<button *adminAccess [routerLink]="['/app/make-payment']" disableRipple mat-menu-item>
    <mat-icon [svgIcon]="'v2:fi-br-dollar'"></mat-icon>
    {{ 'Make a Payment' }}
</button>
<button *hasPermission="'support', requiresWrite: false" (click)="sendIntercomMessage()" disableRipple mat-menu-item>
    <mat-icon [svgIcon]="'v2:fi-br-flag'"></mat-icon>
    {{ 'Submit an Issue' }}
</button>
<button (click)="logout()" disableRipple mat-menu-item>
    <mat-icon [svgIcon]="'v2:fi-br-logout'"></mat-icon>
    {{ 'Sign Out' }}
</button>

<ng-container *ngIf="pmc$ | async as pmc">
    <mat-divider></mat-divider>
    <form class="header-organization-switcher" preventClick>
        <mat-form-field appearance="outline" subscriptSizing="dynamic">
            <mat-icon [svgIcon]="'v2:fi-br-search'" matPrefix></mat-icon>
            <input type="text"
                   aria-label="Search"
                   matInput
                   [placeholder]="'Find organization....'"
                   [formControl]="organizationSearch"
                   (keydown)="$event.stopPropagation()">
            <mat-spinner *ngIf="isSearchingOrganizations" [diameter]="15" matSuffix></mat-spinner>
        </mat-form-field>

        <mat-selection-list multiple="false" (selectionChange)="selectOrganization($event)">
            <cdk-virtual-scroll-viewport [itemSize]="itemHeight" [style.height.px]="viewportHeight">
                <mat-list-option *ngIf="!(mobileMode$ | async)"
                                 [class.option-selected]="true"
                                 [style.height.px]="itemHeight"
                                 [selected]="true"
                                 [value]="pmc"
                                 disableRipple>
                    <span matListItemTitle>{{ pmc.name }}</span>
                    <span matListItemLine>{{ 'PMC Management' }}</span>
                    <mat-icon [svgIcon]="'v2:fi-br-check'" matIconSuffix></mat-icon>
                </mat-list-option>

                <ng-container *cdkVirtualFor="let result of filteredResults">
                    <mat-list-option [style.height.px]="itemHeight" [value]="result" disableRipple>
                        <span matListItemTitle>{{ result.name }}</span>
                        <span matListItemLine>{{ result.demo ? 'TEST DATA - ' : '' }}{{ result.id }}</span>
                    </mat-list-option>
                </ng-container>
            </cdk-virtual-scroll-viewport>
        </mat-selection-list>
    </form>
</ng-container>
